// The Intelliport design system: brand fonts and the colour / type / spacing
// tokens every component reads through theme.ts. Imported first so its :root
// values are in place before any component style resolves against them.
import "./styles/intelliport/styles.css";
// App-level rules layered on top of the design system (imported after it so
// they win on equal specificity).
import "./styles/app.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/msalConfig";
import { installSessionGuard } from "./auth/sessionGuard";
import { applyDevAuth } from "./auth/devAuth";
import { applyLocalAuth } from "./auth/localAuth";
import App from "./App";

const msalInstance = new PublicClientApplication(msalConfig);
// Turn "the Entra session is gone" into a re-login redirect instead of a raw
// error banner on a dead page. Must run BEFORE applyDevAuth, which replaces
// acquireTokenSilent outright in dev-token mode (and then needs no guard).
installSessionGuard(msalInstance);
// No-op unless a dev token is configured (localStorage.devApiToken or
// VITE_DEV_API_TOKEN). When set, MSAL is bypassed for dev/test loop engineering.
applyDevAuth(msalInstance);
// No-op unless an external tester signed in with email + password (localStorage
// `localAuth`). Same bypass as above, carrying the tester's own JWT; a dev
// token wins when both are present.
applyLocalAuth(msalInstance);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
